import {EventEmitter} from 'events';
import Dispatcher from '../dispatcher';
import assign from 'object-assign';

const UtilityStore = assign({}, EventEmitter.prototype, {

  HAMBURGER_STATE: "hambruger.state",

  _state: {},

  _updateState: function(state){
    this._state = state;
    Dispatcher.emit(Dispatcher.RESOURCE_STORE_CHANGE);
  },

  get: function(utility){
    return this._state[utility];
  },

  init: function(){
    Dispatcher.on(Dispatcher.HEADER_HAMBURGER_TOGGLE, ()=>{
      this._state[this.HAMBURGER_STATE] = !this._state[this.HAMBURGER_STATE];
      Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_CHANGE);
    });
    Dispatcher.on(Dispatcher.HEADER_HAMBURGER_OFF, ()=>{
      this._state[this.HAMBURGER_STATE] = false;
      Dispatcher.emit(Dispatcher.HEADER_HAMBURGER_CHANGE);
    });
  },

});

UtilityStore.init();
export default UtilityStore;
